<app-page-loader></app-page-loader>
<router-outlet></router-outlet>

<app-lightbox></app-lightbox>